import Shepherd from 'shepherd.js';
import getBreakpoint from "../helpers/get-breakpoint";

class CollectionsTour {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.allowedBreakpoints = ['lg', 'xl', 'xxl', 'xxxl'];
    }

    init() {
        let self = this;

        const tour = new Shepherd.Tour({
            cancelIcon: {
                enabled: true,
            },
            useModalOverlay: true,
            defaultStepOptions: {
                scrollTo: true,
                popperOptions: {
                    modifiers: [{ name: 'offset', options: { offset: [0, 25] } }]
                }
            }
        });

        // helper to check the browser's localstorage
        function dismissTour(){
            if(!localStorage.getItem('collections-tour')) {
                localStorage.setItem('collections-tour', 1);
            }
        }

        function progressDots() {
            const currentStepElement = tour.currentStep.el;
            const text = currentStepElement.querySelector('.shepherd-text');
            const progress = document.createElement('div');
            progress.classList.add('d-flex');
            progress.classList.add('justify-content-center');
            progress.classList.add('mt-3');

            for (let step = 0; step < tour.steps.length; step++) {
                
                if(step == tour.steps.indexOf(tour.currentStep)) {
                    var dot = document.createElement('span');
                    dot.classList.add('shepherd-progress-dot--current');
                } else {
                    var dot = document.createElement('button');

                    dot.addEventListener('click', evt => {
                        tour.show(step);
                    });
                }

                dot.setAttribute('aria-label', `Go to step ${step + 1}`);

                dot.classList.add('shepherd-progress-dot');

                progress.appendChild(dot);
            }

            text.appendChild(progress);  
        }

        const steps = [
            {
                id: 'filter',
                text: 'Filter collections to find exactly what you are looking for.',
                cancelIcon: {
                    enabled: true,
                },
                attachTo: {
                    element: self.elem.querySelector('[data-collections-tour-filters]'),
                    on: 'bottom'
                },
                buttons: [
                    {
                        text: 'Next',
                        action: tour.next
                    }
                ],
                when: {
                    show() {
                        progressDots();
                    }
                },
                modalOverlayOpeningPadding: 13,
                modalOverlayOpeningRadius: 10
            },
            {
                id: 'share',
                text: 'Share your current search results. Click here to get a link you can share with others.',
                cancelIcon: {
                    enabled: true,
                },
                attachTo: {
                    element: self.elem.querySelector('[data-collections-tour-share]'),
                    on: 'bottom'
                },
                buttons: [
                    {
                        text: 'Back',
                        action: tour.back,
                        secondary: true
                    },
                    {
                        text: 'Next',
                        action: tour.next
                    }
                ],
                when: {
                    show() {
                        progressDots();
                    }
                },
                modalOverlayOpeningPadding: 13,
                modalOverlayOpeningRadius: 10
            },
            {
                id: 'wishlist',
                text: 'Create a wish list of collections and share your wish list by email.',
                cancelIcon: {
                    enabled: true,
                },
                attachTo: {
                    element: self.elem.querySelector('[data-collections-tour-wishlist]'),
                    on: 'bottom'
                },
                buttons: [
                    {
                        text: 'Back',
                        action: tour.back,
                        secondary: true
                    },
                    {
                        text: 'Finish',
                        action() {
                        // Dismiss the tour when the finish button is clicked. Do not show the tour on next page reload.
                            dismissTour();
                            return this.hide();
                        }
                    }
                ],
                when: {
                    show() {
                        progressDots();
                    }
                },
                modalOverlayOpeningPadding: 13,
                modalOverlayOpeningRadius: 10
            }
        ];

        tour.addSteps(steps);

        // Dismiss the tour when the cancel icon is clicked. Do not show the tour on next page reload
        tour.on('cancel', dismissTour);

        // Initiate the tour
        if(!localStorage.getItem('collections-tour') && self.allowedBreakpoints.includes(getBreakpoint())) {
            tour.start();
        }
    }
}

export default CollectionsTour;
